// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1P3Ox","footer":"ModalFilter_footer__3xH9_"};